<template>

  <header class="sticky"
  v-show="showNav1"
  :style="{'background': bg}"
  :class="{
    'mobile': windowWidth<1024,
    'desktop': windowWidth>=1024
    }"
  >
    <nav>
      <div class="lwh">
        Learn with Hato
      </div>
      <router-link exact :to="'/' + urlSuffix">
        <span v-if="windowWidth>=1024">Individual Workshops</span>
        <span v-if="windowWidth<1024">Workshops</span>
      </router-link>
      <!-- <router-link exact :to="'play' + urlSuffix">
        <span v-if="windowWidth>=1024">Private & Corportate</span>
        <span v-if="windowWidth<1024">Bespoke</span>
      </router-link> -->
      <router-link exact :to="'playtotype' + urlSuffix">
        <span  v-if="windowWidth>=1024">Playtotype™ Workshops</span>
        <span v-if="windowWidth<1024">Playtotype™</span>
      </router-link>
      <!-- <router-link exact :to="'strategy' + urlSuffix">Strategy & Partnership</router-link> -->
      <!-- <router-link exact :to="'courses' + urlSuffix">Short Courses</router-link> -->
      <!-- <router-link exact :to="'private' + urlSuffix">Private & Corporate</router-link> -->
      <!-- <router-link exact :to="'strategy' + urlSuffix">Strategy & Partnership</router-link> -->
      <!-- <router-link exact :to="'christmas'">Christmas Workshops</router-link> -->
    </nav>
  </header>

</template>

<script>

export default {
  data () {
    return {
      // showNav1: this.$route.query && this.$route.query.nav === '1',
      // urlSuffix: this.$route.query && this.$route.query.nav === '1' ? '?nav=1' : ''
      showNav1: true,
      urlSuffix: '',
      windowWidth: window.innerWidth
    }
  },
  props: {
    bg: {
      type: String,
      default: 'hsl(158, 90%, 66%)'
    }
  },
  methods: {
    handleWindowResize (event) {
      let self = this
      self.windowWidth = event.currentTarget.innerWidth
    },
    isMobile () {
      let self = this
      return self.windowWidth < 1024
    }
  },
  beforeDestroy: function () {
    let self = this
    window.removeEventListener('resize', self.handleWindowResize)
  },
  mounted () {
    let self = this
    window.addEventListener('resize', self.handleWindowResize)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  /*margin-bottom: 4rem;*/
  /*background: pink;*/
  /* background: #eee; */
  /* background: hsl(159, 89%, 80%); */
  /*padding: 3rem 0;*/
  height: auto;
  padding: .7rem;
  /*top: -1px;*/
  z-index: 9999;

  height: 3rem;
  /*z-index: 9999;*/
  /*background: white;*/
  /*width: 100%;*/
  /*padding: .75rem 1rem;*/
  display: flex;
  justify-content: space-between;
  justify-content: center;
  align-items: center;
}
.sticky {
  position: sticky;
  top: 0;
  top: -1px;
}
nav {
  /*max-width:800px;*/
  width: 100%;
  max-width: 100%;
  border: 0;
  display: flex;
  justify-content: center;
}
a {
  display: block;
  padding: .5em 1.5em;
  margin: 0 .5em;
  border-radius: 2em;
  text-align: center;
  background: #eee;
  border: 1px solid white;

  padding: 0.2em 0em 0em;
  margin: 0 1em;
  border-radius: 0;
  text-align: center;
  background: transparent;
  border: 0;
  line-height: 1;
}
a:hover {
  /*opacity: 0.5;*/
  /*border-bottom: 1.2px solid #000;*/
  /*border: 1px solid #000;*/
}
/*a:nth-child(1) {
  background: #eee
}
a:nth-child(2) {
  background: #eee
}
a:nth-child(3) {
  background: #eee
}*/
.router-link-active {
  /*background: #ccc;*/
  border-bottom: 1.2px solid #000;
  /*background: red;*/
}
.lwh {
  position: relative;
  /*height: 1.3em;*/
  position: absolute;
  left: 0;
  top: 0;
  /*bottom: 0;*/
  height: 3rem;
  padding: 1rem;
  padding: 0.2em 0em 0em 1rem;
  display: flex;
  align-items: center;
  opacity: 0.8;
}

@media screen and (max-width: 1024px) {
  header {
    /* overflow: hidden;
    overflow-x: auto; */
  }
  nav {
    /* justify-content: flex-end; */
    /* padding-right: 0; */
    /* background: red; */
  }
  a {
    margin-right: 0.5rem;
    line-height: 1;
  }
  .lwh {
    position: relative;
    padding-left: 0.3rem;
    height: 1rem;
    /* position: relative;
    white-space: nowrap;
    padding-left: 0.5rem;
    font-size: .8rem; */
    margin-right: auto;
  }
}
@media screen and (max-width: 768px) {
  nav {
    /* justify-content: space-around; */
    /* background: red; */
  }
  .lwh {
    font-size: .9rem;
  }
  a {
    font-size: .9rem;
    /* line-height: 1.3;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 60px;
    white-space: nowrap; */
  }
}
@media screen and (max-width: 640px) {
  a {
    font-size: .9rem;
    /* line-height: 1.3;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 20px; */
  }
}
</style>



// WEBPACK FOOTER //
// Nav1.vue?4f0eb4d4